import React, { useState } from 'react'
import { Tabs } from '../../elements/tabs/Tabs';
import { TexTranslate } from '../../../translations/FlattenMessages';
import "./sass/profile.css";
import { useIntl } from 'react-intl';

import RecoverPassword from '../changePassword/RecoverPassword';


export const Profile = () => {
    
    const intl = useIntl();

    const [activeTab, setActiveTab] = useState('tab1');
    const handleChangeTab = (id) => {
        setActiveTab(id);
    }

    return (
        <div id="profileModule" className="contentProfile">
            <div className="tabMenu">
                <div className="contentTabMenu">
                    <Tabs handleChangeTab={handleChangeTab} dataContent={
                        [
                            { name: TexTranslate(intl, "changePass.Password change"), id: "tab1", active:  (activeTab === 'tab1'), key: 2, visible:true }
                        ]}
                    />
                </div>
            </div>
            <div className="content_full withTab">
                <div className="content_center">
                    <div className="tabContent">
                        <div className="colTabContent">
                            {
                                activeTab === 'tab1' &&
                                    <RecoverPassword handleChangeTab={handleChangeTab}/>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
